import { useState } from "react"
import { ballColorMap } from "../Utils/ColorMap"
import { extractPitchData } from "../Utils/GameReportUtils"
import { wrapPieChartData, wrapPointData, wrapPointDataWithConditions } from "../Utils/PersonChartDataProcess"
import { IntegrateKZoneConfig, IntegrateKZoneConfig2, PitchPortionConfig } from "./Charts/configs/person_configs"
import { H2HPitchLocationFrame, extractBallCount } from "./HeadToHeadFrames"
import { displayBallPortion } from "./IntegratedBCountFrame"
import { BubbleChart } from "./Charts/BubbleChart"
import { PieChart } from "./Charts/PieChart"
import { H2HKZoneConfig2 } from "./Charts/configs/h2h_config"
import { SinglePlayFrame } from "./PersonFrame"
import { SingleSelectionBox2 } from "./InputBox"

export const PitchAnalysisFrame = ({ title, data }) => {
  // console.log(data)
  const [pointData, setPointData] = useState(data.zone)
  const [usageData, setUsageData] = useState(data.usage)

  return (
    <div className="gr_integrate_ball_block">
      <div className="gr_integrate_ball_block_top">{title}</div>
      <div className="gr_integrate_ball_content">
        <div className="gr_integrate_ball_block_zone">
          <BubbleChart config={H2HKZoneConfig2} className='gr_integrate_chart_kzone' data={wrapPointData(pointData, 0.5)} />
        </div>
        <div className="gr_integrate_ball_portion">
          <div className="gr_integrate_ball_pie_chart">
            <PieChart data={wrapPieChartData(usageData, ballColorMap)} config={PitchPortionConfig} />
          </div>
          <div className="gr_integrate_info">
            <table class="no_border">
              {displayBallPortion(usageData)}
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}

export const GameReportPAFrame = ({data, type='pitcher'}) => {
  // console.log(data)
  const pdata = extractPitchData(data, type==='pitcher'?'BatS':'PT')
  return (
    <>
      <div className="page_tab_frame2">
        <div className="tab_block tab_selected">
          <div className="tab">配球分析</div>
        </div>
      </div>
      <div className="person_tab_content">
        <div className="h2h-kzone-body">
          <PitchAnalysisFrame title={type==='pitcher'?'左打':'左投'} data={{zone: pdata.zone.left, usage: pdata.usage.left}} />
          <PitchAnalysisFrame title={type==='pitcher'?'右打':'右投'} data={{zone: pdata.zone.right, usage: pdata.usage.right}} />
        </div>
      </div>
    </>
  )
}

export const GRPitchLocationFrame = ({data, title, side, sidetype}) => {
  const [type, setType] = useState(title)
  const ptypes = ['FB', 'SL', 'CH', 'CB', 'SP', 'SFF', 'SC', 'CT', 'FT', 'KN', 'UN', 'OT']
  const countMap = {
    '0-0': ['0-0'], '1-0': ['1-0'], '2-0': ['2-0'], '3-0': ['3-0'], '0-1': ['0-1'], '1-1': ['1-1'],
    '2-1': ['2-1'], '3-1': ['3-1'], '0-2': ['0-2'], '1-2': ['1-2'], '2-2': ['2-2'], '3-2': ['3-2'],
    blead: ['1-0','2-0','3-0','2-1','3-1'], plead: ['0-1','0-2','1-2'], strike2: ['0-2','1-2','2-2','3-2'], even: ['0-0','1-1','2-2']
  }
  const countLabel = {'0-0': '首球(0-0)', blead: '打者領先', plead: '投手領先', strike2: '2好球', even: '平手'}
  return (
    <div className="h2h-pitch-frame">
      <div className="h2h-pf-title"><SingleSelectionBox2 options={Object.keys(countMap)} optionValueMap={countLabel} value={type} handleOnChange={(e)=>{setType(e.target.value)}} /></div>
      <div className="h2h-pf-content">
        <BubbleChart data={wrapPointDataWithConditions(extractBallCount(data), sidetype, side, ptypes, countMap[type])} config={H2HKZoneConfig2} />
      </div>
    </div>
  )
}

export const GameReportPLocFrame = ({ data, type="pitcher" }) => {
  // console.log(data)
  const [mode1, setMode1] = useState('all')
  const [mode2, setMode2] = useState('all')
  const modeTags = {
    all: '進壘位置', take: '好球未出棒', swing_m: '揮空', inplay: '擊出',
    hit: '安打', xbh: '長打', go: '滾地出局', fo: '飛球出局'
  }
  const LocModes = ({ mode, modes, setMode }) => {
    return (
      <div className="loc-modes-bbody">
        <div className="loc-modes">
          {modes.map((e) => (<div className={`loc-mode-title${e === mode ? " loc-sel-title" : ""}`} onClick={() => { setMode(e) }}><div>{modeTags[e]}</div></div>))}
        </div>
      </div>
    )
  }
  return (
    <>
      <div className="page_tab_frame2">
        <div className="tab_block tab_selected">
          <div className="tab">進壘點</div>
        </div>
      </div>
      <div className="person_tab_content">
        <div>
          <LocModes mode={mode1} modes={['all', 'take', 'swing_m', 'inplay', 'hit', 'xbh', 'go', 'fo']} setMode={setMode1} />
          <div className="gr-sub-title">
            {type==='pitcher'?'左打':'左投'}
          </div>
          <div className="h2h-pf-body">
            <GRPitchLocationFrame data={data[mode1]} sidetype={type==='pitcher'?'bside':'pside'} side='left' title='0-0' />
            <GRPitchLocationFrame data={data[mode1]} sidetype={type==='pitcher'?'bside':'pside'} side='left' title='blead' />
            <GRPitchLocationFrame data={data[mode1]} sidetype={type==='pitcher'?'bside':'pside'} side='left' title='plead' />
            <GRPitchLocationFrame data={data[mode1]} sidetype={type==='pitcher'?'bside':'pside'} side='left' title='strike2' />
          </div>
        </div>
        <div>
          <div className="gr-sub-title">
            {type==='pitcher'?'右打':'右投'}
          </div>
          <div className="h2h-pf-body">
            <GRPitchLocationFrame data={data[mode1]} sidetype={type==='pitcher'?'bside':'pside'} side='right' title='0-0' />
            <GRPitchLocationFrame data={data[mode1]} sidetype={type==='pitcher'?'bside':'pside'} side='right' title='blead' />
            <GRPitchLocationFrame data={data[mode1]} sidetype={type==='pitcher'?'bside':'pside'} side='right' title='plead' />
            <GRPitchLocationFrame data={data[mode1]} sidetype={type==='pitcher'?'bside':'pside'} side='right' title='strike2' />
          </div>
        </div>
      </div>
    </>
  )
}

export const GRPlayByPlayFrame = ({data, type='pitcher'}) => {
  const [inn, setInn] = useState(Object.keys(data).at(-1))
  const [pbpTags, setPBPTags] = useState(Object.keys(data))
  const [pbpdata, setPBPData] = useState(data)
  // console.log(data, pbpdata, inn)
  const displayPlays = (data) => {
    // console.log(data)
    return data.map((e) => {
      return <SinglePlayFrame playData={e} />
    })
  }
  const displayTabs = (inns) => {
    return inns.map((e) => (
        <div className={e===inn? 'inn_tab_block tab_selected':'inn_tab_block'} onClick={(evt)=>{setInn(e)}}>
          <div className='tab inn_tab'>{e}</div>
        </div>
    ))
  }
  const concatInningPlays = (obj) => {
    let output = []
    for (let inn in obj) {
      output = output.concat(obj[inn])
    }
    return output
  }
  return (
    <>
      <div className='page_tab_frame2'>
        {type==='pitcher'? displayTabs(pbpTags):[]}
      </div>
      <div className='tab_content tab_content_gray'>
        {data===undefined? 'NO RESULT':(type==='pitcher'? displayPlays(pbpdata[inn]):displayPlays(concatInningPlays(pbpdata)))}
      </div>
    </>
  )
}